<script lang="ts" setup>
import OmniDialog from "@/components/OmniDialog.vue";
import OmniSelect from "@/components/controls/OmniSelect.vue";
import { ref, watch } from "vue";
import { IntervalOptions } from "@/data/trip";

const props = defineProps<{
  title: string;
  interval: number | null;
  truckNumber: string | undefined;
  truckId: number | undefined;
}>();

const emits = defineEmits<{
  (e: "update:modelValue", value: boolean): void;
  (e: "updateInterval", interval: number | null): void;
}>();

const isDialog = defineModel<boolean>({ default: false });
const intervalModel = ref<number | null>(props.interval);

function save() {
  emits("updateInterval", intervalModel.value);
  emits("update:modelValue", false);
}

watch(
  () => props.interval,
  (value) => {
    intervalModel.value = value;
  },
);
</script>

<template>
  <omni-dialog
    v-model="isDialog"
    :title="props.title"
    primary-action-label="Save"
    secondary-action-label="Reset changes"
    @primary-action:click="save"
    @secondary-action:click="intervalModel = 120"
  >
    <template v-if="truckNumber" #title:append>
      <div class="d-flex align-center ml-2">
        <v-icon class="mr-1" color="primary" size="24">mdi-truck-outline</v-icon>
        <router-link
          v-if="truckId"
          :to="{ name: 'truck-view', params: { id: truckId } }"
          class="text-primary font-weight-500 font-size-16 text-decoration-none"
          target="_blank"
        >
          Truck #{{ truckNumber }}
        </router-link>
      </div>
    </template>
    <v-form>
      <span class="text-grey-darken-1">Please, set how often you want to do check calls for this route</span>

      <omni-select
        v-model="intervalModel"
        :items="IntervalOptions"
        class="mt-20px"
        label="Check calls frequency"
      ></omni-select>
    </v-form>
  </omni-dialog>
</template>

<style lang="scss" scoped></style>
